<template>
  <!--== Start Header Wrapper ==-->
  <header class="header">
    <!-- header-middle start -->
    <div class="header-middle mobile-sticky">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="header-middle-content">
              <div class="header-logo">
                <a href="">
                  <img class="sticky-img" src="@/assets/picture/logo.png" alt="Logo" style="width: 180px;">
                </a>
              </div>
              <ul class="media-wrap d-none d-lg-flex">
                <!-- media-list start -->
<!--                <li class="media media-list">
                  <span class="media-icon"><i class="icofont-clock-time"></i></span>
                  <div class="media-content">
                    <span class="media-sub-heading">工作时间</span>
                    <span class="media-heading">周一到周五: {{ basicInfo.worktime }} </span>
                  </div>
                </li>-->
                <!-- media-list end -->

                <!-- media-list start -->
                <!-- <li class="media media-list">
                  <span class="media-icon"><i class="icofont-envelope"></i></span>
                  <div class="media-content">
                    <span class="media-sub-heading">联系邮箱 7X24小时</span>
                    <a class="media-heading" :href="'mailto:'+basicInfo.email">{{ basicInfo.email }}</a>
                  </div>
                </li> -->
                <!-- media-list end -->

              </ul>

              <div class="mobile-menu-toggle d-lg-none">
                <a href="#offcanvas-mobile-menu" class="offcanvas-toggle">
                  <span class="icon icofont-navigation-menu"></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- header-middle end -->

    <!-- header-bottom start -->
    <div class="header-bottom d-none d-lg-block">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="d-flex flex-wrap align-items-center justify-content-between">
              <ul class="main-menu">
                <li :class="navIndex==index?'active':''" v-for="(item,index) in navList">
                  <a class="main-menu-link" @click="navClick(index)"  :href="item.path">{{ item.name }}</a>
                  <ul class="sub-menu" v-if="item.children.length>0">
                    <li  v-for="itemSub in item.children">
                      <a class="sub-menu-link" @click="navClick(index)"  :href="itemSub.path">{{ itemSub.name }}</a>
                    </li>
                  </ul>
                </li>
              </ul>

            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- header-bottom end -->
    <!-- header-bottom start -->
    <div class="header-bottom sticky-header d-none d-lg-block">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="d-flex flex-wrap align-items-center justify-content-between">
              <ul class="main-menu">
                <li :class="navIndex==index?'active':''" v-for="(item,index) in navList">
                  <a class="main-menu-link" @click="navClick(index)" :href="item.path">{{ item.name }}</a>
                  <ul class="sub-menu" v-if="item.children.length>0">
                    <li  v-for="itemSub in item.children">
                      <a class="sub-menu-link" @click="navClick(index)"  :href="itemSub.path">{{ itemSub.name }}</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- header-bottom end -->

    <!-- offcanvas-overlay start -->
    <div class="offcanvas-overlay"></div>
    <!-- offcanvas-overlay end -->
    <!-- offcanvas-mobile-menu start -->
    <div id="offcanvas-mobile-menu" class="offcanvas offcanvas-mobile-menu">
      <div class="inner">
        <div class="border-bottom mb-3 pb-3 text-end">
          <button class="offcanvas-close">×</button>
        </div>
        <div class="offcanvas-head mb-3">
          <div class="header-top-offcanvas">
            <p>
              <i class="icofont-google-map"></i> <span>公司地址:</span>{{ basicInfo.address }}
            </p>
          </div>
        </div>
        <nav class="offcanvas-menu">
          <ul>
            <li :class="navIndex==index?'active':''" v-for="(item,index) in navList">
              <a class="menu-text" @click="navClick(index)" :href="item.path">{{ item.name }}</a>
              <ul class="offcanvas-submenu" v-if="item.children.length>0">
                <li  v-for="itemSub in item.children">
                  <a @click="navClick(index)"  :href="itemSub.path">{{ itemSub.name }}</a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>

        <ul class="media-wrap">
          <!-- media-list start -->
<!--          <li class="media media-list">
            <span class="media-icon"><i class="icofont-clock-time"></i></span>
            <div class="media-content">
              <span class="media-sub-heading">工作时间</span>
              <span class="media-heading">周一到周五: {{ basicInfo.worktime }} </span>
            </div>
          </li>-->
          <!-- media-list end -->

          <!-- media-list start -->
          <!-- <li class="media media-list">
            <span class="media-icon"><i class="icofont-envelope"></i></span>
            <div class="media-content">
              <span class="media-sub-heading">联系邮箱 7X24小时</span>
              <a class="media-heading" :href="'mailto:'+basicInfo.email">{{ basicInfo.email }}</a>
            </div>
          </li> -->
          <!-- media-list end -->

        </ul>
      </div>
    </div>
    <!-- offcanvas-mobile-menu end -->

  </header>
</template>
<script>
import {mapState} from "vuex"

export default {
  name: "Header",
  components: {
  },
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "SAAS服务",
          path: "/saas",
          children: []
        },
        // {
        //   name: "产业园招商",
        //   path: "/merchant",
        //   children: []
        // },
        {
          name: "就业服务",
          path: "/employment",
          children: []
        },
        {
          name: "人力资源服务",
          path: "/services/home",
          children: [
            {
              name: "岗位外包",
              path: "/services/job"
            },
            {
              name: "劳动派遣",
              path: "/services/dispatch"
            },
            // {
            //   name: "灵活用工",
            //   path: "/services/flexible"
            // },
            // {
            //   name: "人事代理",
            //   path: "/services/agency"
            // },
            {
              name: "残疾人就业保障",
              path: "/services/guarantee"
            },
            {
              name: "员工福利",
              path: "/services/welfare"
            },
            {
              name: "就业招聘",
              path: "/services/recruit"
            }
          ]
        },
        {
          name: "增值服务",
          path: "/increase",
          children: [
            {
            name: "保险服务",
            path: "/increase#insurance"
          },
            {
              name: "咨询服务",
              path: "/increase#consulation"
            }]
        },
        {
          name: "关于汉工云",
          path: "/aboutus",
          children: []
        },
        // {
        //   name: "联系汉工云",
        //   path: "/contactus",
        //   children: []
        // },
        {
          name: "登录系统",
          path: "javascript:void(0);;",
          link: "https://hgy.hangongyun.com/",
          children: []
        }
      ]
    };
  },
  computed: {
    ...mapState({
      basicInfo:state=>state.basicInfo,
    })
  },
  mounted() {
/*    let data = localStorage.getItem("INFO");
    if(data){
      this.basicInfo=JSON.parse(data)
    }*/

    this.setActive()
  },
  methods: {
    navClick(index) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      if(this.navList[index].link && this.navList[index].link!=''){
        window.open(this.navList[index].link,'_blank')
      }
    },
    setActive(){
      const uri=window.location.pathname;
      console.log(uri)
      sessionStorage.setItem('navIndex',0)
      for(var i=0;i<this.navList.length;i++){
        console.log(this.navList[i])
        if(this.navList[i].children.length>0){
          console.log(this.navList[i])
          for(var j=0;j<this.navList[i].children.length;j++){
              if(uri.indexOf(this.navList[i].children[j].path)>-1){
                sessionStorage.setItem('navIndex',i)
                this.navIndex=i;
                console.log("1111111>>",i)
                return;
              }
          }
        }else{
          if(uri.indexOf(this.navList[i].path)>-1 && this.navList[i].path!='/'){
            sessionStorage.setItem('navIndex',i)
            console.log("222222>>",i)
            return;
          }
        }
      }
    }
  }
};
</script>
<style scoped>
  a.offcanvas-toggle{
    color:white;
    font-size: 25px;
    line-height: 30px;
  }
  .sticky a.offcanvas-toggle{
    color:#0a53be;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue